import React from 'react';
import { useTranslation } from 'react-i18next';
import { Hash, Circle } from 'lucide-react';
import { pickLang, RTL_LANGS, COMMON, tt } from '@/utils/localizedStrings';

const ClockTypeSelector = ({ clockType, onChange, textColors, surfaceColors }) => {
  const { i18n } = useTranslation();
  const lang = pickLang(i18n.language);
  const isRTL = RTL_LANGS.has(lang);
  const isLightMode = textColors.primary !== '#FFFFFF';

  const options = [
    {
      id: 'digital',
      label: tt(COMMON.digital, lang),
      Icon: Hash
    },
    {
      id: 'analog',
      label: tt(COMMON.analog, lang),
      Icon: Circle
    }
  ];

  return (
    <div
      className="inline-flex items-center gap-1 p-1 rounded-xl"
      style={{
        background: 'rgba(255, 255, 255, 0.08)',
        border: `1px solid ${surfaceColors.border}`
      }}
      data-testid="clock-type-selector"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      {options.map(opt => {
        const Icon = opt.Icon;
        const isActive = clockType === opt.id;
        return (
          <button
            key={opt.id}
            onClick={() => onChange(opt.id)}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs transition-all"
            style={{
              background: isActive ? textColors.accent : 'transparent',
              color: isActive
                ? (isLightMode ? '#FFFFFF' : '#050914')
                : textColors.secondary,
              fontWeight: isActive ? 600 : 400
            }}
            data-testid={`clock-type-${opt.id}`}
          >
            <Icon size={13} />
            <span>{opt.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ClockTypeSelector;
